import { BrowserRouter, Routes, Route } from 'react-router-dom';
/* test routes */
import PrivateRoute from '../../Components/Admin/Functions/PrivateRoute.js';
import { RoutesNoSqlTest } from '../../Pages/Testing/RoutesNoSqlTest.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const TestRoutesNoSQL = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PrivateRoute />}>
                    <Route path={`/admin/test/routes/nosql`} element={<RoutesNoSqlTest />} />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    )
}